import Header_Text from "../Components/Header-text";
import Image from "../Components/Image";
import ME from '../Text_Files/About_Me.txt';
import SKILL from '../Text_Files/Skills.txt';
import PROJECTS from '../Text_Files/Projects.txt';
import { useEffect, useState, useRef} from 'react';
import "../css/home.css";
import { send } from "@emailjs/browser";




function Home({headshot, id, outerScrollRef, sendDataToApp}){
    const index = useRef(0);
    const texts = ["About Gaby", "Skills", "Projects"];
    //const [data, setData] = useState(texts[index.current]);

    //ABOUT ME
    const [headText, setHeadText] = useState("");
    //PROJECTS
    const [projText, setProjText] = useState("");
    //SKILLS
    const [skillText, setSkillText] = useState("");

    const innerscrollRef = useRef(null);
    const time = useRef(Date.now());
    const [scrollFlag, setScrollFlag] = useState(true);
    const userScrolling = useRef(false);

    const endScroll = (e) => {
        setScrollFlag(true);
    }


    const handleScroll = (e) => {
        var data = "";
        if(Date.now() - time.current > 800){
            time.current = Date.now();
            if(index.current < 2 && e.deltaY > 0){
                index.current ++;
                data = texts[index.current];
                sendDataToApp(data);
                // setData(texts[index.current]);
                // console.log("After Index: " + index.current);
                // console.log(texts[index.current])
            }
            else if (index.current > 0 && e.deltaY<0){
                index.current --;
                data = texts[index.current];
                sendDataToApp(data);
                // setData(texts[index.current]);
                // console.log("After Index: " + index.current);
            }
            setScrollFlag(false);

        }else{
            console.log(Date.now)
            
        }
        //console.log(e.deltaY)
        
    }
    //setData(texts[index]);
    //sendDataToApp(data);

    

    useEffect (() => {
        fetch(ME)
            .then(r => r.text())
            .then(text => {
                setHeadText(text);
            });
    }, []);
    useEffect (() => {
        fetch(SKILL)
            .then(r => r.text())
            .then(text => {
                setSkillText(text);
            });
    }, []);
    useEffect (() => {
        fetch(PROJECTS)
            .then(r => r.text())
            .then(text => {
                setProjText(text);
            });
    }, []);

  



    useEffect (() => {
        const inner = innerscrollRef.current;
        const outer = outerScrollRef.current; 
        if(!inner) return;


        const handleWheel = (e) => {
             

            const buffer = 50;

            //Calculate Top Section +- buffer
            const atTop = inner.scrollTop <= buffer;
            //Calculate Bottom Section +- buffer
            const atBottom = inner.scrollTop + inner.clientHeight >= inner.scrollHeight - buffer;
            
            if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY >0)){
                e.preventDefault();
                outer.scrollBy({
                    top: e.deltaY,
                    behavior: "smooth", // avoid 'smooth' to preserve scroll snap/momentum
                   
                });
            }else{
                console.log("SCROLLING");

             }
        };

        inner.addEventListener("wheel", handleWheel, {passive:false});
        return () => inner.removeEventListener("wheel", handleWheel);
    }, []);


    return (
        <div className={"main-content " + id} id={id}>
            <div className="inner-scroll-wrapper" ref={innerscrollRef} onWheel={handleScroll} onScrollEnd={endScroll}>
                <div className="inner-scroll-section" >
                    <Header_Text className="About" Header="I love to tell stories." Text={headText}></Header_Text>
                </div>
                <div className="inner-scroll-section" >
                    <Header_Text className="About" Header="My Work" Text={skillText}></Header_Text>
                </div>
                <div className="inner-scroll-section">
                    <Header_Text className="About" Header="Projects" Text={projText}></Header_Text>
                </div>
            </div>
                <Image link={headshot} className="Headshot"></Image>
        </div>
    );
}

export default Home;